import React from 'react'
import { useStore } from 'react-redux'
import PropTypes from 'prop-types'
import {
  getOption,
  getOptions,
  defaultGetText,
  defaultGetValue,
  createOption
} from 'utils/searchField'
import MultiSearchField from '../Basic/MultiSearchCreateField'

const UniversalMultiSearchField = props => {
  const { api, params, itemText, ...rest } = props
  const store = useStore()
  return (
    <MultiSearchField
      getText={(a) => {
        return defaultGetText(itemText)(a)
      }}
      getValue={defaultGetValue(['id'])}
      getOptions={search => getOptions(store, { api, params, search })}
      getOption={getOption(store, { api, params })}
      createOption={value => createOption(store, { api, value })}
      isMulti={true}
      itemText={itemText}
      {...rest}
    />
  )
}

UniversalMultiSearchField.propTypes = {
  api: PropTypes.string.isRequired,
  params: PropTypes.object,
  itemText: PropTypes.array,
}

UniversalMultiSearchField.defaultProps = {
  itemText: ['name']
}

export default UniversalMultiSearchField
